import { css, html, LitElement } from 'lit';

export class BizPopup extends LitElement {
  static properties = {
    open: { type: Boolean, reflect: true },
    title: { type: String },
  };

  declare open: boolean;
  declare title: string;

  constructor() {
    super();
    this.open = false;
    this.title = '';
  }

  static styles = css`
    :host {
      display: none;
    }
    :host([open]) {
      display: block;
      position: fixed;
      inset: 0;
      background: rgba(0, 0, 0, 0.6);
      z-index: 100;
    }
    .card {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: #1f2128;
      border: 1px solid #2c2e36;
      border-radius: 8px;
      padding: 1.5rem;
      min-width: 280px;
      max-width: 90vw;
    }
    h2 {
      margin-top: 0;
    }
    .actions {
      margin-top: 1rem;
      display: flex;
      justify-content: flex-end;
      gap: 0.5rem;
    }
  `;

  render() {
    return html`
      <link rel="stylesheet" href="/static/style.css" />
      <div class="card">
        ${this.title
          ? html`
            <h2>${this.title}</h2>
          `
          : null}
        <slot></slot>
        <div class="actions">
          <button class="secondary" @click="${() => this.#close()}">Close</button>
        </div>
      </div>
    `;
  }

  #close() {
    this.open = false;
    this.dispatchEvent(new CustomEvent('close', { bubbles: true, composed: true }));
  }
}

customElements.define('biz-popup', BizPopup);
